import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = [
  {
    label: 'DAO',
    icon: 'HomeIcon',
    href: 'https://app.kronosdao.ai', //  'https://www.goosedefi.com/'
  },
  {
    label: 'Trade',
    icon: 'TradeUpdatedIcon',
    initialOpenState: true,
    items: [
      {
        label: 'Exchange',
        href: '#/swap'
      },
      {
        label: 'Liquidity',
        href: '#/pool'
      }
    ]


  },
  
  
 
 
  // {
  //   label: 'Lottery',
  //   icon: 'TicketIcon',
  //   href: 'https://www.goosedefi.com/lottery'
  // },
  // {
  //   label: 'Info',
  //   icon: 'InfoIcon',
  //   items: [
  //     {
  //       label: 'PancakeSwap',
  //       href: 'https://pancakeswap.info/token/0xF952Fc3ca7325Cc27D15885d37117676d25BfdA6',
  //     },
  //     {
  //       label: 'CoinGecko',
  //       href: 'https://www.coingecko.com/en/coins/goose-finance',
  //     },
  //     {
  //       label: 'CoinMarketCap',
  //       href: 'https://coinmarketcap.com/currencies/goose-finance/',
  //     },
  //     {
  //       label: 'AstroTools',
  //       href: 'https://app.astrotools.io/pancake-pair-explorer/0x19e7cbecdd23a16dfa5573df54d98f7caae03019',
  //     },
  //   ]
  // },


  {
    label: 'Socials',
    icon: 'MoreIcon',
    items: [
      {
        label: "Github",
        href: "https://github.com/Kronos-DaoDefi/launchContracts",
      },
      {
        label: "Twitter",
        href: "https://twitter.com/dao_kronos",
      },
      {
        label: "Telegram",
        href: "https://t.me/KRONOS_community",
      },

      {
        label: "Medium",
        href: "https://medium.com/@kronos_dao",
      },
    ],
  },




  // {
  //   label: 'Partnerships/IFO',
  //   icon: 'GooseIcon',
  //   href: 'https://docs.google.com/forms/d/e/1FAIpQLSe7ycrw8Dq4C5Vjc9WNlRtTxEhFDB1Ny6jlAByZ2Y6qBo7SKg/viewform?usp=sf_link',
  // },
  // {
  //   label: 'Audit by Hacken',
  //   icon: 'AuditIcon',
  //   href: 'https://www.goosedefi.com/files/hackenAudit.pdf',
  // },
  // {
  //   label: 'Audit by CertiK',
  //   icon: 'AuditIcon',
  //   href: 'https://certik.org/projects/goose-finance',
  // },
]

export default config
